import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Fallbacks ensure the site renders cleanly while the API is loading.
const DEFAULTS = {
  business_name: "Spark Scooter Repairs",
  address_line: "",
  city: "",
  region: "",
  country: "New Zealand",
  phone: "",
  email: "",
  website: "",
  facebook_url: null,
  instagram_url: null,
  tiktok_url: null,
  google_maps_url: null,
  logistics_available: true,  // optimistic default — the real value loads in a moment
  logistics_unavailable_message: null,
};

let cache = null;
let inflight = null;
const subscribers = new Set();

const fetchSettings = () => {
  if (cache) return Promise.resolve(cache);
  if (inflight) return inflight;
  inflight = api.get("/settings/public")
    .then((res) => {
      cache = { ...DEFAULTS, ...res.data };
      subscribers.forEach((cb) => cb(cache));
      return cache;
    })
    .catch(() => {
      cache = { ...DEFAULTS };
      return cache;
    })
    .finally(() => { inflight = null; });
  return inflight;
};

/** React hook — returns the latest public settings, or sane defaults during load. */
export const usePublicSettings = () => {
  const [settings, setSettings] = useState(cache || DEFAULTS);

  useEffect(() => {
    let alive = true;
    if (!cache) {
      fetchSettings().then((s) => { if (alive) setSettings(s); });
    } else {
      setSettings(cache);
    }
    const cb = (s) => { if (alive) setSettings(s); };
    subscribers.add(cb);
    return () => { alive = false; subscribers.delete(cb); };
  }, []);

  return settings;
};

/** Force-refresh the cache (call after settings save). */
export const refreshPublicSettings = async () => {
  cache = null;
  return fetchSettings();
};
